import {Redirect, Route, Switch} from 'react-router-dom';
import {
  frontCounterHotspots,
  frontBodyHotspots,
  bodyHotspots,
  backBodyHotspots
} from './data';
import CBScene from './CBScene';
import Urls from '../../constants/urls';

const CBRooms = () => {
  return (
    <Switch>
      <Route 
        {...Urls.campionBoatRoom.root}
        render={() => <Redirect to={Urls.campionBoatRoom.root} />}  
      />

      <Route {...Urls.campionBoatRoom.frontCounter}>
        <CBScene
          id="cb-front-counter"
          yRotation={360}
          hotspots={frontCounterHotspots}
        />
      </Route>
      <Route {...Urls.campionBoatRoom.frontBody}>
        <CBScene 
          id="cb-front-body"
          yRotation={360}
          hotspots={frontBodyHotspots}
        />
      </Route> 
      <Route {...Urls.campionBoatRoom.backBody}>
        <CBScene
          id="cb-back-body"
          yRotation={360}
          hotspots={backBodyHotspots}
        />
      </Route> 
      <Route {...Urls.campionBoatRoom.body}>
        <CBScene
          id="cb-body"
          yRotation={360}
          hotspots={bodyHotspots}
        />
      </Route>    
    </Switch>
  );
};

export default CBRooms;
